

import { cleanDate } from '../date-helpers.js';

import Lexer from "./lexer.js";

import { ASTNumber, ASTDate, ASTIdentifier, ASTFunction, ASTBinary } from "./ast.js";



class Parser {
  constructor() {
    this.lexer = new Lexer();

    this.curToken = {};
    this.lookahead = this.lexer.TT_EOD;
  }


  parseModelExpression(expr) {
    this.lexer.input(expr);

    var result = {
      errors: false,
      message: "",
      expr: null
    };

    try {

      this.getNextToken();

      result.expr = this.parseExpression();

      if (this.curToken.type !== this.lexer.TT_EOD) {
        throw "To many symbols";
      }
    } catch (err) {
      result.errors = true;
      result.message = err;
    }

    return result;
  }


  parseScenarioElement(expr) {
    this.lexer.input(expr);

    var result = {
      errors: false,
      message: "",
      stmt: null
    }

    try {
      this.getNextToken();

      result.stmt = this.parseDirective();

      if (this.curToken.type !== this.lexer.TT_EOD) {
        throw "To many symbols";
      }
    } catch (err) {
      result.errors = true;
      result.message = err;
    }

    return result;
  }


  //--------------------------------------------------------------------------------
  //--------------------------------------------------------------------------------

  parseExpression() {
    return this.parseConditionalExpr();
  }


  parseDirective() {

    var stmt = {
      isPartial: false,  // Some of the elements are present - still being edited
      isComplete: false, // All the required elements are present - done editing

      instruction: "",
      item: "",
      amount: "",

      startDate: "",
      endDate: ""
    };


    if ( this.peekLookahead(this.lexer.TT_RW_INCREASE) || this.peekLookahead(this.lexer.TT_RW_DECREASE) || this.peekLookahead(this.lexer.TT_RW_SET) ) {
      stmt.instruction = this.curToken.value;

      this.match( this.lookahead );
    } else {
      this.error( 20, "Expected instruction" );
    }
    stmt.isPartial = true;

    if ( this.lookahead === this.lexer.TT_STRING || this.lookahead === this.lexer.TT_IDENTIFIER ) {
      stmt.item = this.curToken.value;

      this.match( this.lookahead );
    } else {
      this.error( 30, "Expected item" );
    }


    this.matchOptional( this.lexer.TT_RW_BY );

    stmt.amount = this.curToken.value;

    this.match( this.lexer.TT_NUMBER );


    this.match( this.lexer.TT_RW_ON );


    stmt.startDate = this.curToken.value;

    this.match( this.lexer.TT_DATE );


    stmt.isComplete = true;

    return stmt;
  }


  matchPredicateToken( type ) {
    var val = this.curToken.value.toLowerCase();

    this.match( type );

    return val;
  }


  parseConditionalExpr() {
    return this.parseLogicalOrExpr();
  }


  parseLogicalOrExpr() {
    let left = this.parseLogicalAndExpr();

    while ( true ) {
      if ( this.peekLookahead(this.lexer.TT_RW_OR) ) {
        Match( this.lexer.TT_RW_OR );

        let right = this.parseLogicalAndExpr();

        left = new ASTBinaryLogical( AST.OP_OR, left, right );
      } else {
        break;
      }
    } // while true

    return left;
  }


  parseLogicalAndExpr() {
    let left = this.parseEqualityExpr();

    while ( true ) {
      if ( this.peekLookahead(this.lexer.TT_RW_AND) ) {
        Match( this.lexer.TT_RW_AND );

        let right = this.parseEqualityExpr();

        left = new ASTBinaryLogical( AST.OP_AND, left, right );
      } else {
        break;
      }
    } // while true

    return left;
  }


  parseEqualityExpr() {
    let left = this.parseRelationalExpr();

    if (this.peekLookahead(this.lexer.TT_RW_EQ) || this.peekLookahead(this.lexer.TT_RW_NE)) {
      let node_type = AST.OP_EQ;
      if (this.peekLookahead(this.lexer.TT_RW_NE))
        node_type = AST.OP_NE;

      Match(this.lookahead);
      
      let right = this.parseRelationalExpr();

      left = new ASTBinary( node_type, left, right );
    }

    return left;
  }


  parseRelationalExpr() {
    let left = this.parseAdditiveExpr();

    if (this.peekLookahead(this.lexer.TT_RW_LT) || 
        this.peekLookahead(this.lexer.TT_RW_LE) ||
        this.peekLookahead(this.lexer.TT_RW_GT) ||
        this.peekLookahead(this.lexer.TT_RW_GE) 
    ) {
      let node_type = AST.OP_LT;
      if (this.peekLookahead(this.lexer.TT_RW_LE))
        node_type = AST.OP_LE;
      else if (this.peekLookahead(this.lexer.TT_RW_GT))
        node_type = AST.OP_GT;
      else if (this.peekLookahead(this.lexer.TT_RW_GE))
        node_type = AST.OP_GE;

      Match(this.lookahead);
      
      let right = this.parseAdditiveExpr();

      left = new ASTBinary( node_type, left, right );
    }

    return left;
  }


  parseAdditiveExpr() {
    let left = this.parseMultiplicativeExpr();

    if (this.peekLookahead(this.lexer.TT_PLUS) || this.peekLookahead(this.lexer.TT_MINUS)) {
      let node_type = AST.OP_ADD;
      if (this.peekLookahead(this.lexer.TT_MINUS))
        node_type = AST.OP_SUB;

      Match(this.lookahead);
      
      let right = this.parseMultiplicativeExpr();

      left = new ASTBinary( node_type, left, right );
    }

    return left;
  }


  parseMultiplicativeExpr() {
    let left = this.parsePrimaryExpression();

    if (this.peekLookahead(this.lexer.TT_MULTIPLY) || this.peekLookahead(this.lexer.TT_DIVIDE)) {
      let node_type = AST.OP_MUL;
      if (this.peekLookahead(this.lexer.TT_DIVIDE))
        node_type = AST.OP_DIV;

      Match(this.lookahead);
      
      let right = this.parsePrimaryExpression();

      left = new ASTBinary( node_type, left, right );
    }

    return left;
  }


  parsePrimaryExpression() {
    var expr = null;

    if (this.curToken.type === this.lexer.TT_DATE) {
      expr = this.processDate();
    } else if (this.curToken.type === this.lexer.TT_NUMBER) {
      expr = this.processNumber();
    } else if (this.curToken.type === this.lexer.TT_IDENTIFIER) {
      expr = this.parseIdentifier();
    } else {
      throw "Syntax error";
    }

    return expr;
  }


  processDate() {
    var val = cleanDate(this.curToken.value, 0);

    this.match( this.lexer.TT_DATE );

    var expr = new ASTDate(val);
    return expr;
  }


  processNumber() {
    var val = parseInt(this.curToken.value);

    this.match( this.lexer.TT_NUMBER );

    var expr = new ASTNumber(val);
    return expr;
  }


  parseIdentifier() {
    var name = this.curToken.value;

    this.match( this.lexer.TT_IDENTIFIER );

    if (this.lookahead === this.lexer.TT_L_PAREN) {
      return this.parseFunctionCall(name);
    }

    var expr = new ASTIdentifier(name);
    return expr;
  }


  parseFunctionCall(name) {
    this.match( this.lexer.TT_L_PAREN );

    var expr = new ASTFunction(name);

    while (true) {
      if (this.lookahead === this.lexer.TT_R_PAREN)
        break;

      var param = this.parseExpression();
      expr.params.push(param);

      if (this.lookahead !== this.lexer.TT_COMMA)
      break;

      this.match( this.lexer.TT_COMMA );
    }

    this.match( this.lexer.TT_R_PAREN );

    return expr;
  }


  match(token) {
    if (this.curToken.type === token) {
      this.getNextToken();
    } else {
      this.error( 10, "Expected Symbol " + token + " but got " + this.curToken.type );
    }
  }


  matchOptional(token) {
    if ( this.lookahead === token ) {
      this.match( token );
    }
  }


  peekLookahead(token) {
    return this.lookahead === token;
  }


  getNextToken() {
    this.curToken = this.lexer.token();
    this.lookahead = this.curToken.type;
  }

  error( code, desc ) {
    var msg = code.toString() + ":  " + desc;
    throw msg;

  }
}


export default Parser;

